/** @format */
import Script from 'next/script';
import React, { FunctionComponent } from 'react';

import { useEmbedlyState } from './useEmbedlyState';

export const Embedly: FunctionComponent = () => {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    const [loadEmbedlyScript, processEmbeds] = useEmbedlyState();

    return loadEmbedlyScript ? (
        <Script
            id="embedly-script"
            src="//cdn.embedly.com/widgets/platform.js"
            data-testid="embedly-script"
            onLoad={processEmbeds}
        />
    ) : null;
};
